import {
  Attribute,
  AttributeId,
  AttributeValue,
  Attributes,
  RawAttribute,
} from 'jobs.types';
import { ABTEILUNG_ATTRIBUTE_ID } from '../constants';

const refineAttributes = (data: RawAttribute[]): Attributes => {
  const sortedAttributes = data.sort((a, b) => (a.id > b.id ? 1 : -1));
  const newAttributes: Attributes = {};

  sortedAttributes.forEach((att) => {
    if (att.id === ABTEILUNG_ATTRIBUTE_ID) {
      return;
    }

    const attribute: Attribute = {};
    attribute.name = att.name;
    attribute.id = att.id as AttributeId;
    attribute.values = [];

    // add entry for all checkbox
    const emptyValues = {
      id: '0',
      name: 'all',
    };
    attribute.values.push(emptyValues);

    // add values from API
    Object.keys(att.values).forEach((key) => {
      const attributeValues: AttributeValue = {
        id: key,
        name: att.values[key] as unknown as string,
      };
      attribute.values.push(attributeValues);
    });

    newAttributes[att.id] = attribute;
  });

  return newAttributes;
};

export default refineAttributes;
